// 这里放置一些Vue自定义Filter
export const formatDate = time => {
  if (time) {
    let tmpDate = new Date(time)
    let year = tmpDate.getFullYear()
    let mathon = tmpDate.getMonth() + 1
    if (mathon < 10) {
      mathon = '0' + mathon
    }
    let day = tmpDate.getDate()
    if (day < 10) {
      day = '0' + day
    }
    return year + '-' + mathon + '-' + day
  } else {
    return '-'
  }
}

export const formatDateByChinese = time => {
  if (time) {
    let tmpDate = new Date(time)
    let year = tmpDate.getFullYear()
    let mathon = tmpDate.getMonth() + 1
    if (mathon < 10) {
      mathon = '0' + mathon
    }
    let day = tmpDate.getDate()
    if (day < 10) {
      day = '0' + day
    }
    return year + '年' + mathon + '月' + day + '日'
  } else {
    return '-'
  }
}

export const formatTime = time => {
  if (!time) {
    return '-'
  }
  let tmpDate = new Date(time)
  let year = tmpDate.getFullYear()
  let mathon = tmpDate.getMonth() + 1
  if (mathon < 10) {
    mathon = '0' + mathon
  }
  let day = tmpDate.getDate()
  if (day < 10) {
    day = '0' + day
  }
  let hours = tmpDate.getHours()
  if (hours < 10) {
    hours = '0' + hours
  }
  let minutes = tmpDate.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  return year + '-' + mathon + '-' + day + ' ' + hours + ':' + minutes
}

export const formatTimeBySeconds = time => {
  if (!time) {
    return '-'
  }
  let tmpDate = new Date(time)
  let year = tmpDate.getFullYear()
  let mathon = tmpDate.getMonth() + 1
  if (mathon < 10) {
    mathon = '0' + mathon
  }
  let day = tmpDate.getDate()
  if (day < 10) {
    day = '0' + day
  }
  let hours = tmpDate.getHours()
  if (hours < 10) {
    hours = '0' + hours
  }
  let minutes = tmpDate.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  let seconds = tmpDate.getSeconds()
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  return year + '-' + mathon + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
}

export const formatTimeUseable = val => {
  if (val && val > 0) {
    var days = val / 1000 / 60 / 60 / 24
    var daysRound = Math.floor(days)
    var hours = val / 1000 / 60 / 60 - 24 * daysRound
    var hoursRound = Math.floor(hours)
    var minutes = val / 1000 / 60 - 24 * 60 * daysRound - 60 * hoursRound
    var minutesRound = Math.floor(minutes)
    var seconds = val / 1000 - 24 * 60 * 60 * daysRound - 60 * 60 * hoursRound - 60 * minutesRound
    let timeUse = ''
    if (days >= 1) {
      timeUse = '剩余' + daysRound + '天'
    } else if (hours < 24 && hours >= 1) {
      timeUse = '剩余' + hoursRound + '时'
    } else if (minutesRound < 60 && minutesRound >= 1) {
      timeUse = minutesRound + '分'
    } else {
      timeUse = '剩余' + seconds + '秒'
    }
    return timeUse
  } else {
    return '已过期'
  }
}
